import React from 'react';

export const Unban: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='var(--primary-accent)'
      d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
    ></path>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 11.417a2.918 2.918 0 010-5.834 2.918 2.918 0 010 5.834zm0-4.667c-.962 0-1.75.787-1.75 1.75 0 .962.788 1.75 1.75 1.75.963 0 1.75-.788 1.75-1.75 0-.963-.787-1.75-1.75-1.75zM5.583 17.833H5.52a.587.587 0 01-.517-.654C5.045 16.881 5.829 12 12 12c1.068 0 2.048.17 2.91.497.304.116.45.449.34.752a.587.587 0 01-.753.339c-.735-.28-1.575-.42-2.497-.42-5.244 0-5.816 3.955-5.839 4.147a.581.581 0 01-.578.52zm10.734-4.095h1.166v1.517H19v1.167h-1.517v1.516h-1.166v-1.516H14.8v-1.167h1.517v-1.517z'
      clipRule='evenodd'
    ></path>
  </svg>
);
